import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const planId = searchParams.get("planId");

  useEffect(() => {
    // Clear the subscription cache so next fetch gets fresh data
    localStorage.removeItem("subscription_type");

    // Small delay for the DB to update via Stripe webhook
    const timer = setTimeout(() => {
      navigate("/dashboard/Home", { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F4F6F9",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 48,
          textAlign: "center",
          boxShadow: "0 6px 24px rgba(0,0,0,0.1)",
          maxWidth: 400,
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h1 style={{ color: "#1F2937", marginBottom: 8 }}>
          Upgrade Successful!
        </h1>
        <p style={{ color: "#6B7280", marginBottom: 24 }}>
          Your plan has been upgraded. Redirecting you to the dashboard...
        </p>
        <div
          style={{
            width: "100%",
            height: 4,
            backgroundColor: "#E5E7EB",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              backgroundColor: "#4F46E5",
              borderRadius: 4,
              animation: "progress 3s linear forwards",
            }}
          />
        </div>
        <style>{`
          @keyframes progress {
            from { width: 0% }
            to { width: 100% }
          }
        `}</style>
      </div>
    </div>
  );
};

export default PaymentSuccess;
